import { httpRequest } from "@services/http";
import { normalizeLinkState } from "@models/launchNetworkLinks.model";
import type { NetworkLinkObjectType, NetworkLinkState } from "@models/launchNetworkLinks.model";

export interface PatchNetworkLinkPayload {
  // Any subset. JSON fields (network_ids, data) are replaced wholesale server-side.
  status?: string;
  network_ids?: string[];
  dirty?: boolean;
  data?: Record<string, any>;
}

export class CommandPatchLaunchNetworkLink {
  async run(
    launchId: number,
    network: string,
    kind: NetworkLinkObjectType,
    objectId: number,
    payload: PatchNetworkLinkPayload,
  ): Promise<NetworkLinkState> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/launches/${launchId}/networks/${network.toLowerCase()}/links/${kind}/${objectId}/`;
    const updated = await httpRequest<NetworkLinkState>(url, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
    return normalizeLinkState(updated);
  }
}
